import { render, staticRenderFns } from "./deliveryBlock.vue?vue&type=template&id=099810ec&scoped=true&"
import script from "./deliveryBlock.vue?vue&type=script&lang=js&"
export * from "./deliveryBlock.vue?vue&type=script&lang=js&"
import style0 from "./deliveryBlock.vue?vue&type=style&index=0&id=099810ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099810ec",
  null
  
)

export default component.exports